<template>
  <view-wrapper
    :show-back-button="false"
    name="QualityAssuranceLabels"
    :loading="loading"
    loading-text="Loading QualityAssuranceLabels">

    <div class="float-right font-semibold">
      <span v-if="!!message">
        {{message}}
      </span>
    </div>

    <filter-and-sort-box :data="labels" :headers="headers" :useSearch="false">
      <template v-slot:d="{ d }">
        <td class="py-1 relative" v-for="(key, index) in getKeys(d)" :key="key + index">
          <div class="bg-primary-light py-4 pl-4 w-full" :class="{ 'rounded-l' : index === 0, 'rounded-r' : Object.keys(headers).length - 1 === index } ">
            <span v-if="key === 'labelId'" class="inline-block w-10/12">{{d[key] ? d[key] : ''}}</span>
            <span v-if="key === 'name'" class="inline-block w-10/12">{{d[key] ? d[key] : ''}}</span>
          </div>
        </td>
        <td class="py-1 relative" >
          <div style="padding-bottom: 0.6rem; padding-top: 0.6rem;" class="bg-primary-light justify-end pr-4 flex rounded-r" >
            <grafokett-button class="primary" @click="gotoLabel(d.labelId)"> Go to details </grafokett-button>
          </div>
        </td>
      </template>
    </filter-and-sort-box>

  </view-wrapper>
</template>

<script>

import GrafokettButton from '../../../components/forms/Button.vue'
import FilterAndSortBox from '../../../components/FilterAndSortBox';

export default {
  components: {
    GrafokettButton,
    FilterAndSortBox
  },
  data: () => ({
    loading: false,
    message: "",
    scanId: null,
    headers: {
      labelId: 'Label Id',
      name: 'Label name',
    }
  }),
  computed: {
    allLabels () {
      return this.$store.getters['LABELS/LABELS'].map(l => {
        return {
          id: l.labelId,
          labelId: l.labelId,
          name: l.name,
          disabled: l.disabled,
          modified: (new Date(l.modified)).toLocaleDateString('sv-SE'),
          expandableData: {
            variabels: l.variables.map(v => {
              return {
                name: v.name,
                description: v.propertyDescription,
                length: v.propertySize,
                IsFixedLength: v.propertySize !== 0,
                locked: !v.editable,
                boundToName: !v.boundToId ? v.name : l.variables.filter(e => e.id === v.boundToId)[0].name
              }
            }),
            groups: l.groups
          }
        }
      })
    },
    labels() {
      return this.allLabels.filter(l => !l.disabled);
    }
  },
  methods: {
    async getData () {
      this.loading = true;
      await this.$store.dispatch('LABELS/GET_LABELS')
      this.loading = false;
    },
    gotoLabel(labelId) {
      this.$router.push(`/qa/labels/${labelId}/details`);
    },
    getKeys(order){
      return Object.keys(order).filter(key => {
        return key === 'name' || key === 'labelId'
      })
    },
  },
  async mounted () {
    await this.getData();
  }
}
</script>
